import { isHttpClientError } from "@/http";
import type { ServerInfoSnapshot } from "./serverInfoController";

export const MASK_GENERATION_DISABLED_MESSAGE =
  "마스크 생성 연동 검증 중입니다. Annotation Set을 쓰는 Training은 검증 완료 후 다시 시도해 주세요.";

/** 설정 확인 실패와 비활성화를 구분하고, 활성화가 확인됐을 때만 선택을 허용한다. */
export function maskGenerationBlockReason(snapshot: ServerInfoSnapshot): string | null {
  if (snapshot.failed) return "마스크 생성 설정을 확인하지 못했습니다. 잠시 후 다시 확인해 주세요.";
  if (snapshot.loading || snapshot.data === null) return "마스크 생성 설정을 확인하고 있습니다.";
  return snapshot.data.capabilities.training_mask_generation_enabled
    ? null
    : MASK_GENERATION_DISABLED_MESSAGE;
}

export function isMaskGenerationDisabledError(error: unknown): boolean {
  return isHttpClientError(error) && error.code === "training.mask_generation_disabled";
}
